/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Vehicle types:   * `CAR` - car   * `TRUCK` - truck   * `CAR_GT` - fast car   * `TUK_TUK` - tuk-tuk   * `BICYCLE` - bicycle   * `PEDESTRIAN` - pedestrian         * `PUBLIC_TRANSPORT` - public transport 
 */
export enum TransportTypeLastmile {
    CAR = 'CAR',
    TRUCK = 'TRUCK',
    CAR_GT = 'CAR_GT',
    TUK_TUK = 'TUK_TUK',
    BICYCLE = 'BICYCLE',
    PEDESTRIAN = 'PEDESTRIAN',
    PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT'
};

